function getKeyMomentFormats(exponent) {

  return exponent?._keyMomentLinks?.map((keyMomentLink) => keyMomentLink._keyMoment.format);
}


export { getKeyMomentFormats }